import { render, staticRenderFns } from "./CurePlanEdit.vue?vue&type=template&id=56ddeb43&scoped=true&"
import script from "./CurePlanEdit.vue?vue&type=script&lang=js&"
export * from "./CurePlanEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ddeb43",
  null
  
)

export default component.exports